/* Browser-only signals. The IP address is deliberately absent: the backend reads it
   from the request headers, where the client cannot forge it. */

export type ContactMetadata = {
    submitted_at: string
    timezone: string
    languages: string
    page_url: string
    referrer: string
    platform: string
    screen: string
    viewport: string
    pixel_ratio: string
    touch_points: string
}

export function collectMetadata(): ContactMetadata {
    const now = new Date()

    return {
        submitted_at: now.toISOString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'unavailable',
        languages: navigator.languages?.join(', ') || navigator.language || 'unavailable',
        page_url: window.location.href,
        referrer: document.referrer || 'direct',
        platform: navigator.platform || 'unavailable',
        screen: `${window.screen.width}x${window.screen.height}`,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        pixel_ratio: String(window.devicePixelRatio),
        touch_points: String(navigator.maxTouchPoints ?? 0),
    }
}

